var css = {"container":"TextArea-module_container__3uRKV","rightElement":"TextArea-module_rightElement__FUcIV","inputLabel":"TextArea-module_inputLabel__mrl1l","lifted":"TextArea-module_lifted__qs-m6","focused":"TextArea-module_focused__AblJ9"};

export { css as default };
